







import Vue from 'vue'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

interface ComponentData {
  chart: any
}

export default Vue.extend({
  name: 'HolidayBalanceChart',

  components: {},

  props: {
    label: String,
    data: {
      type: Array as () => Array<any>
    }
  },

  data (): ComponentData {
    return {
      chart: undefined
    }
  },

  mounted() {
    //@ts-ignore
    let chart = am4core.create(this.$refs.columnChart, am4charts.XYChart);

    // Add data
    chart.data = this.data

    // Add and configure Series
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "mitarbeiter";
    categoryAxis.renderer.grid.template.location = 0;

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.min = 0;
    categoryAxis.renderer.minGridDistance = 20;

    // Create series
    function createSeries(field: string, name: string, color: string): any {

      // Set up series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.name = name;
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "mitarbeiter";
      series.sequencedInterpolation = true;

      // Make it stacked
      series.stacked = true;

      // Configure columns
      series.columns.template.width = am4core.percent(60);
      series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

      // Add label
      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueY}";
      labelBullet.locationY = 0.5;
      labelBullet.label.hideOversized = true;
      series.columns.template.fill = am4core.color(color);
      //series.stroke = am4core.color("#D50000")
      return series;
    }

    createSeries("bezogen", "Bezogen", "#BBDEFB");
    createSeries("ferienSaldo", "Ferien Saldo", "#43A047");
    createSeries("zuVielBezogen", "Zu viel bezogen", "#D50000");

    // Legend
    chart.legend = new am4charts.Legend();
    //chart.cursor = new am4charts.XYCursor();

    this.chart = chart;
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

})
